/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ModalBody/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DebugAction from './DebugAction/index'
import React from 'react'
import ScanAction from './ScanAction/index'
import Sources from './Sources/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import UseNewDriverAction from './UseNewDriverAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ModalBody({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/ImportFromDevices/Content/ModalBody"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dwtOnSourceChangeValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'onSourceChange',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<Sources
{...childProps}
  viewPath={`${viewPath}/Sources`}
 data="dwt.onSourceChange"
 onSourceChange={dwtOnSourceChangeValueData}
/>
<div
  data-testid="ModalBody.Vertical"
  data-view-path={viewPath}
 id="dwtControlContainerId"
 style={{'--mt-1-Z8Mghs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-2-Z8Mghs': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-3-Z8Mghs': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-4-Z8Mghs': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-Z8Mghs': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-6-Z8Mghs': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical}`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<UseNewDriverAction
{...childProps}
  viewPath={`${viewPath}/UseNewDriverAction`}
/>
<DebugAction
{...childProps}
  viewPath={`${viewPath}/DebugAction`}
/>
<ScanAction
{...childProps}
  viewPath={`${viewPath}/ScanAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}